<template>
    <div class="header">
        <div class="header_box w">
            <!-- logo 、 导航 -->
            <div class="logo_nav">
                <div class="logo_box">
                    <img src="~assets/images/common/logo.png" class="logo" style="height:53px" />
                </div>
                <div class="main-tarbar-container">
                    <tar-bar>
                        <!-- <tar-bar-item path="/pcViews/index">
                            <div slot="item-text">首页</div>
                        </tar-bar-item> -->
                        <!-- <tar-bar-item >
                            <div slot="item-text">在线学习</div>
                        </tar-bar-item>
                        <tar-bar-item >
                            <div slot="item-text">信息模块</div>
                        </tar-bar-item> -->
                        <tar-bar-item path="/pcViews/learn" :hasSecond="true">
                            <div slot="item-text">在线学习</div>
                            <second-tar-bar slot="item-second-nav">
                                <second-tar-bar-item
                                    path="/pcViews/learn/train"
                                >
                                    <p slot="item-second-nav-text">教育培训</p>
                                </second-tar-bar-item>
                                <!-- <second-tar-bar-item
                                    path="/pcViews/learn/university"
                                >
                                    <p slot="item-second-nav-text">老年大学</p>
                                </second-tar-bar-item>
                                <second-tar-bar-item
                                    path="/pcViews/learn/class-room"
                                >
                                    <p slot="item-second-nav-text">市民课堂</p>
                                </second-tar-bar-item> -->
                            </second-tar-bar>
                        </tar-bar-item>
                        <tar-bar-item path="/pcViews/information">
                            <div slot="item-text">信息模块</div>
                        </tar-bar-item>
                    </tar-bar>
                </div>
            </div>
            <!-- 搜索、用户信息 -->
            <div class="search_login">
                <div id="search_login">
                    <!-- <div class="search_box">
                        <el-input
                            placeholder="请输入搜索内容"
                            v-model.trim="content"
                        >
                            <el-button
                                slot="append"
                                icon="el-icon-search"
                                @click="query"
                            ></el-button>
                        </el-input>
                    </div> -->
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link">
                            <div
                                class="header_msg"
                                v-if="$store.state.auth.jsessId != undefined"
                            >
                                <img
                                    :src="headImg"
                                    alt="用户头像"
                                    class="userImg"
                                />
                                <div class="userName">{{ userName }}</div>
                            </div>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                icon="el-icon-user-solid"
                                command="/pcViews/personal"
                            >
                                个人中心
                            </el-dropdown-item>
                            <el-dropdown-item
                                align="center"
                                command="out"
                                class="loginOut"
                                @mouseenter.native="hover = true"
                                @mouseleave.native="hover = false"
                            >
                                <img
                                    src="~assets/images/personal/loginOut.svg"
                                    v-show="!hover"
                                    alt=""
                                />
                                <img
                                    src="~assets/images/personal/loginOuta.svg"
                                    v-show="hover"
                                    alt=""
                                />
                                退出登录
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TarBar from "components/common/tarbar/TarBar";
import TarBarItem from "components/common/tarbar/TarBarItem";
import SecondTarBar from "components/common/secondtarbar/SecondTarBar";
import SecondTarBarItem from "components/common/secondtarbar/SecondTarBarItem";

import VueEvent from '@/VueEvent.js'
import { PcCookie, Key } from "@/utils/cookie";

import { getUserNews } from "@/api/personal";
export default {
    inject: ["reload"],
    name: "MainTarBar",
    components: {
        TarBar,
        TarBarItem,
        SecondTarBar,
        SecondTarBarItem,
    },
    data() {
        return {
            //搜索内容
            content: "",
            hover: false,
            jsessId: this.$store.state.auth.jsessId,
            userName: PcCookie.get(Key.userInfoKey),
            headImg:
                PcCookie.get(Key.headImgKey) != undefined
                    ? PcCookie.get(Key.headImgKey)
                    : require("@/assets/images/personal/defaultHeadImg.png"),
        };
    },
    mounted() {
        VueEvent.$on("changeHeadImg", () => {
            this.reload();
        });
        VueEvent.$on("passUsrName", (data) => {
            this.userName = data;
            const sessionId = PcCookie.get(Key.jsessIdKey);
            getUserNews(sessionId).then((res) => {
                if (res.errorCode === "2000") {
                    var data = res.body.data;
                    if (data.photo != undefined) {
                        PcCookie.set(Key.headImgKey, data.photo);
                        this.headImg = data.photo;
                    }
                }
            });
        });
        VueEvent.$on("enterLogin", (data) => {
            this.visible = data;
        });
    },
    methods: {
        //内容搜索
        query() {
            console.log("搜索内容了");
        },
        handleCommand(command) {
            if (command === "/pcViews/personal") {
                this.$router.push(command);
            }else {
                this.$store.dispatch("UserLogout").then((res) => {
                    console.log(res,"**************")
                    if (res.success === "1") {
                        this.$router.push("/pcViews/login");
                    } else {
                        this.$message({
                            message: res.msg,
                            type: "error",
                        });
                    }
                });
            }
        },
    },
};
</script>

<style>
.loginOut img {
    margin-right: 5px;
}
.loginOut {
    padding-left: 19px;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #0647aa;
    color: #fff;
}
</style>
<style>
.search_login .el-input__inner {
    height: 30px;
    line-height: 30px;
    border-color: #e5e5e5;
    padding: 0 0 0 15px;
    border-radius: 15px 0 0 15px;
}
.search_login .el-button {
    padding: 8px 15px;
}

.search_login .el-button {
    font-size: 16px;
}

.search_login .el-input-group__append {
    background: #fff;
    border-radius: 0 15px 15px 0;
}
.search_login .el-input-group {
    width: 290px;
}
</style>

<style scoped>
.userName {
    flex: 1;
    font-size: 16px;
    color: #3b3b3b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
.userImg {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: solid 1px #a6a6a6;
    margin-right: 8px;
}
.header_msg {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 12px;
    width: 140px;
    box-sizing: content-box;
}
.user_box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    color: #000000;
    font-size: 14px;
    font-family: "宋体";
}
.user_box p {
    cursor: pointer;
}
.user_box span {
    margin: 0 8px;
}
.search_box {
    height: 32px;
    margin-top: 22px;
    margin-right: 30px;
}
#search_login {
    height: 100%;
    display: flex;
    flex-direction: row;
}
.search_login {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    height: 100%;
    color: #fff;
}
.main-tarbar-container {
    display: flex;
    height: 70px;
    padding-top: 20px;
    font-size: 16px;
    box-sizing: content-box;
}
.logo_box {
    margin-right: 72px;
}
.logo_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.logo_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header_box {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.header {
    height: 90px;
    background: #fff;
}
</style>
